import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function CaretDownIcon({ size = '14px', className }: IIconProps) {
  return (
    <IconWrapper size={size} className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 7L10 13L3.5 7"
          stroke="#01425F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
